import "core-js/modules/es.number.constructor.js";
export default {
  props: {
    percent: {
      type: Number,
      default: 10
    }
  }
};